import { Episode, EpisodeLoadingState } from '../types/Episode';
import { getEpisodeBySlug } from '../services/episodesLoader';
import { useAsyncData } from './useAsyncData';

/**
 * Hook to load a single episode by slug (includes full content)
 *
 * Usage:
 *   const { episode, loading, error } = useEpisode('my-episode-slug');
 */
export function useEpisode(slug: string): EpisodeLoadingState {
  const { data, loading, error } = useAsyncData<Episode | null>(
    async () => {
      if (!slug) return null;

      const episode = await getEpisodeBySlug(slug);
      if (!episode) {
        throw new Error('Episode not found');
      }
      return episode;
    },
    [slug],
    {
      errorMessage: 'Failed to load episode',
      hmrEventName: 'episodes-updated',
      skip: !slug
    }
  );

  return {
    episode: data,
    loading,
    error
  };
}
